import { navigate } from "gatsby"
import React, { useState, useEffect, useRef } from "react"
import { MdKeyboardArrowLeft } from "react-icons/md"
import Layout from "../../../components/layout/layout/layout"
import constants from "../../../services/constants_fhaa"
import media from "../../../services/media"
import story from "../../../services/story"
import Webfile from "../../common/display/webfile/webfile"
import GenericMessage from "../../common/generic-message/generic-message"
import ViewMedia from "../view-media/view-media"
import ViewStory from "../view-story/view-story"
import styles from "./detailed-file.module.scss"
import _ from "lodash"
import moment from "moment"
import classNames from "classnames"
import util from "../../../services/util"
import axios from "axios"

// const baseUrl = process.env.GATSBY_FEDIA_DMS_PORT && process.env.GATSBY_FEDIA_DMS_PORT !== '80' && process.env.GATSBY_FEDIA_DMS_PORT !== 80 ? 
//   `https://${process.env.GATSBY_FEDIA_DMS_HOST}:${process.env.GATSBY_FEDIA_DMS_PORT}/` :
//   `http://${process.env.GATSBY_FEDIA_DMS_HOST}/`;

const fixUrl = webViewUrl => {
  let baseUrl = ''
  if (webViewUrl.includes('http://')) {
    baseUrl = util.baseUrl()
  }
  else {
    baseUrl = util.baseUrl().replace('http://', '')
  }

  return webViewUrl ? `${util.baseUrl()}${webViewUrl.replace(baseUrl, '').toLowerCase().replace('http://appst-fedia-pq7u6wd4330r-317694051.ca-central-1.elb.amazonaws.com/','')}` : webViewUrl;
}

const DetailedFile = ({ id, type, location, fnSetLastRefreshDate, groupDisplay, onMediaUpdated }) => {
  const [item, setItem] = useState()
  const [message, setMessage] = useState("Loading Media...")
  const [messageType, setMessageType] = useState("info")
  const [showingInvalid, setShowingInvalid] = useState(false)
  const [isHovered, setIsHovered] = useState(false)
  const isLoadingRef = useRef(false)
  const lastFetchedIdRef = useRef(null)

  // console.log('location:', location)

  // TODO use Router/route to handle and pass this in???
  // var params = location.search
  //   .split("?mediaId=")
  //   .pop()
  //   .split("&mediaType=")
  // if (!params || params.length === 0) {
  //   params = [null, null]
  // }
  // var id = params[0]
  // var type = params[1] ? params[1] : null

  // if (location && location.state && location.state.id) {
  //   id = location.state.id
  // }

  // if (location && location.state && location.state.type) {
  //   type = location.state.type
  // }

  const getHoverVideoUrl = () => {
    if (!item || !item.webViewUrl) return null;


    var videoUrl = item.webViewUrl;
    videoUrl = videoUrl.replace("/webView/", "/download/");
    console.log('Detailed file Hover url:', videoUrl);

    return videoUrl;
  }

  const showInvalidMedia = () => {
    if (!showingInvalid) {
      // prevent re-render loop
      setShowingInvalid(true)
      // there was missing information. Let the user know
      setMessage("Invalid Media")
      setMessageType("error")
      autoNavBack()
    }
  }

  const autoNavBack = () => {
    // there was no media to load. Go back to search
    setTimeout(() => {
      onBackClick()
    }, 5000)
  }

  useEffect(() => {
    if (id) {
      // Only fetch if we haven't already fetched this ID
      if (lastFetchedIdRef.current !== id) {
        // Prevent multiple simultaneous calls
        if (isLoadingRef.current) {
          return
        }
        
        isLoadingRef.current = true
        lastFetchedIdRef.current = id
        setShowingInvalid(false)
        setMessage("Loading Media...")
        setMessageType("info")

        if (!type || (type && type.toLowerCase() !== "story")) {
          console.log('Getting Media:', id)
          media.getMedia(id).then(
            media => {
              isLoadingRef.current = false
              setItem(media)
            },
            error => {
              isLoadingRef.current = false
              lastFetchedIdRef.current = null // Reset on error so we can retry
              setMessage("File not found")
              setMessageType("error")
              autoNavBack()
            }
          )
        } else if (type && type.toLowerCase() === "story") {
          story.getStory(id).then(
            story => {
              isLoadingRef.current = false
              setItem(story)
            },
            error => {
              isLoadingRef.current = false
              lastFetchedIdRef.current = null // Reset on error so we can retry
              setMessage("File not found")
              setMessageType("error")
              autoNavBack()
            }
          )
        }
      }
    } else {
      showInvalidMedia()
    }
  }, [id, type])

  const onBackClick = async () => {

    console.log('Location:', location)
    if (location.state && location.state.path) {
      const _searchState =
        // when we have state information we can use it to assist navigation (for preserving previous searches)
        navigate(location.state.path, {
          state: _.extend({ useComponentId: true }, location.state.searchState),
        })
    } else {
      await navigate("/")
    }
  }

  const getHeaderHeroImageWrapper = () => {
    const innerStoryHeader = (
      <>
        <div className={styles?.info}>
          <h2 className={styles?.title}>{item.title}</h2>
          <p className={styles?.subtitle}>
            {moment(item.createdAt)
              .format("MMM DD, YYYY")
              .toString()}
            <span> | </span> By{" "}
            {item.uploadedByUsername
              ? item.uploadedByUsername
              : item.uploadedBy}
          </p>
        </div>
        <span className={styles?.mask}></span>
      </>
    )
    console.log('Item Media', item.media)
    if (item && item.media && item.media.length > 0) {
      console.log('Url:', fixUrl(item.media[0].webViewUrl))
      let url =  fixUrl(item.media[0].webViewUrl)
      if (process.env.GATSBY_FEDIA_DMS_HOST === 'api.fedia-test.com' || process.env.GATSBY_FEDIA_DMS_HOST === 'api.fedia-api.com') {
        url = url.replace('localhost:1337/', '')
      }  
      const lastIndex = url.lastIndexOf('/')
      url = url.substring(0, lastIndex + 2)

      return (
        <div
          className={styles?.heroImage}
          style={{
            backgroundImage: `url(${url})`,
          }}
        >
          {innerStoryHeader}
        </div>
      )
    } else {
      return <div>{innerStoryHeader}</div>
    }
  }

  const getHeader = () => {
    if (item && item.type && item.type.toLowerCase() === "story") {
      return (
        <div className={styles?.storyWrap}>
          {/* <div className={styles?.container}>
            <div className={styles?.back}>
              <a id="return-to-list" onClick={onBackClick}>
                <MdKeyboardArrowLeft /> Go Back
              </a>
            </div>
          </div> */}
          {getHeaderHeroImageWrapper()}
        </div>
      )
    } else {
      // default header for all other media (or when no media)
      return (
        <div className={styles?.mediaWrap}>
          <div className={classNames(styles?.container, styles?.hoverContainer)}
                onClick={openFullImage}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
          >
            {isHovered && item?.type?.toLowerCase() === "video" && (
                <div className={styles?.overlay}>
                  <video
                    src={getHoverVideoUrl()}
                    autoPlay
                    muted
                    loop
                    playsInline
                    className={styles?.videoPreview}
                  />
                </div>
              )}
            {item ? (
              // <div className={styles?.back}>
              //   <a id="return-to-list" onClick={onBackClick}>
              //     <MdKeyboardArrowLeft /> Go Back
              //   </a>
              // </div>
              ""
            ) : (
              ""
            )}
            <div
              className={classNames(
                styles?.view,
                (item && item.type && item.type.toLowerCase() === "document") ||
                  (item && item.type && item.type.toLowerCase() === "archive") ||
                  (item && item.type && item.type.toLowerCase() === "audio")
                  ? styles?.iconView
                  : ""
              )}
            >
              <div className={styles?.box}>
                {item ? <Webfile item={item} type={item.type} viewMedia={true}/> : ""}
              </div>
            </div>
          </div>
        </div>
      )
    }
  }

  const openFullImage = () => {
    if (!item.webViewUrl) {
      console.warn("No webViewUrl found on item.");
      return;
    }

    var imageUrl = fixUrl(item.webViewUrl);
    const updatedUrl = imageUrl.replace("/webview/", "/download/");

    const newWindow = window.open("", "_blank", "width=800,height=600");
    if (newWindow) {
      newWindow.document.write(`
        <html>
          <head><title>Image Viewer</title></head>
          <body style="margin:0">
            <img src="${updatedUrl}" style="width:100%;height:auto;" />
          </body>
        </html>
      `);
      newWindow.document.close();
    }
    
  }
  const handleMouseEnter = () => {
    setIsHovered(true)
  }
  
  const handleMouseLeave = () => {
    setIsHovered(false)
  }

  const handleMediaUpdated = updatedItem => {
    // keep this view's copy current, then pass the saved item up
    setItem(updatedItem)
    if (onMediaUpdated) {
      onMediaUpdated(updatedItem)
    }
  }

  const getContent = () => {
    if (item.type && item.type.toLowerCase() !== "story") {
      return (
          <div>
            <div>
              {getHeader()}

            </div>
            <div className={styles?.mainContent}>
              <ViewMedia
                item={item}
                location={location}
                groupDisplay={groupDisplay}
                onMediaUpdated={handleMediaUpdated}
              ></ViewMedia>
            </div>
          </div>
      )
    } else {
      return <ViewStory item={item} location={location} groupDisplay={groupDisplay}>{getHeader()}</ViewStory>
    }
  }

  if (item) {
    return (
      <div key={item._id} className={styles?.wrapper}>
        <div className={styles?.mainContent}>{getContent()}</div>
      </div>
    )
  } else {
    return (
        <GenericMessage message={message} type={messageType} />
    )
  }
}

export default DetailedFile
